import React from "react";
import { Toaster } from "react-hot-toast";
import { Route, Routes, useLocation } from "react-router";

import Container from "@mui/material/Container";

import Header from "../common/components/header/Header";
import RequireKeycloakAuth from "../common/components/RequireKeycloakAuth";
import ScrollTop from "../common/components/scrollTop/ScrollTop";
import Sidebar from "../common/components/sidebar/Sidebar";
import Toolsbar from "../common/components/toolsbar/Toolsbar";
import AccessDenied from "../common/pages/AccessDenied";
import Checkout from "../common/pages/checkout/Checkout";
import Home from "../common/pages/Home";
import Monitoring from "../common/pages/monitoring/Monitoring";
import NotFound from "../common/pages/NotFound";
import Profile from "../common/pages/profile/Profile";
import LoginKeycloak from "../features/auth/LoginKeycloak";

import styles from "../styles/app.module.css";

import { useSelector } from "react-redux";
import RequireAdmin from "../common/components/RequireAdmin";
import Adminspace from "../common/pages/adminspace/Adminspace";
import { OnlineStatusProvider } from "../common/utils/OnlineStatusProvider";
import { authSelector } from "../features/auth/authSlice";
import { displaySelector } from "../features/display/displaySlice";

const App = () => {
  const display = useSelector(displaySelector);
  const auth = useSelector(authSelector);
  const location = useLocation();

  //if (location.pathname === "/access-denied") 
  if (location.pathname === "/access-denied") {
    return <AccessDenied />;
  }
  return (
    <>
      <OnlineStatusProvider>
        <div>
          <Toaster />
        </div>
        {auth.user && (
          <>
            <Toolsbar />
            <Sidebar />
            <Header />
          </>
        )}
        <main id="mainId" className={display.isDisplaySidebar ? styles.mainBlockReduce : auth.user ? styles.mainBlockFull : styles.mainBlockForbidden}>
          <Container className={styles.mainContainer}>
            <Routes>
              <Route
                path="/"
                element={
                  <RequireKeycloakAuth>
                    <Home />
                  </RequireKeycloakAuth>
                }
              />
              <Route path="not-found" element={<NotFound />} />
              <Route
                path="monitoring"
                element={
                  <RequireKeycloakAuth>
                    <Monitoring />
                  </RequireKeycloakAuth>
                }
              />
              <Route
                path="adminspace"
                element={
                  <RequireKeycloakAuth>
                    <RequireAdmin>
                      <Adminspace />
                    </RequireAdmin>
                  </RequireKeycloakAuth>
                }
              />
              <Route
                path="checkout"
                element={
                  <RequireKeycloakAuth>
                    <Checkout />
                  </RequireKeycloakAuth>
                }
              />
              <Route path="login" element={<LoginKeycloak />} />
              <Route path="*" element={<NotFound />} />
              <Route
                path="profile"
                element={
                  <RequireKeycloakAuth>
                    <Profile />
                  </RequireKeycloakAuth>
                }
              />
            </Routes>
          </Container>
        </main>
        <ScrollTop />
      </OnlineStatusProvider>
    </>
  );
};

export default App;
